/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'karate': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 1.27c-.96-.55-2.18-.23-2.73.73-.56.95-.23 2.18.73 2.73A2 2 0 0019.73 4c.55-.96.22-2.18-.73-2.73m2.27 8.07l-2.57 4.45-1.74-1 1.73-3-1.55-1.29L14 13.92V22h-2v-8.61l-9.53-5.5 1-1.73 7.8 4.5 2.4-4.16-6.39-2.33L8 2.29l6.73 2.45.27.1c.39.16.76.31 1.12.51l.84.49c.35.2.69.44 1 .7l.23.2 3.08 2.6z"/>'
  }
})
